module.exports = __webpack_public_path__ + "03_glasses_black.0c3e91af.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer4/03_glasses_black.png
// module id = 7a6/
// module chunks = 0